import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _typeof from "@babel/runtime/helpers/esm/typeof";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { MainStore } from '~/store/index';
var AppModule = /*#__PURE__*/function (_VuexModule) {
  _inherits(AppModule, _VuexModule);
  var _super = _createSuper(AppModule);
  function AppModule() {
    var _this;
    _classCallCheck(this, AppModule);
    _this = _super.apply(this, arguments);
    _this.currenTitle = 'Agrovertrouwen';
    _this.ErrorState = false;
    _this.ErrorMessage = '';
    return _this;
  }
  _createClass(AppModule, [{
    key: "setPageTitle",
    value: function setPageTitle(inputTitle) {
      this.currenTitle = inputTitle;
    }
  }, {
    key: "setStateToError",
    value: function setStateToError(errorMessage) {
      this.ErrorState = true;
      this.ErrorMessage = errorMessage;
    }
  }, {
    key: "setStateToOk",
    value: function setStateToOk() {
      this.ErrorState = false;
      this.ErrorMessage = '';
    }
  }]);
  return AppModule;
}(VuexModule);
__decorate([Mutation], AppModule.prototype, "setPageTitle", null);
__decorate([Mutation], AppModule.prototype, "setStateToError", null);
__decorate([Mutation], AppModule.prototype, "setStateToOk", null);
AppModule = __decorate([Module({
  namespaced: true,
  name: 'AppModule',
  dynamic: true,
  store: MainStore
})], AppModule);
export default AppModule;